import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import JoditEditor from "jodit-react";

interface EditAsHtmlModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  initialValue: string;
  onSave: (html: string) => void;
}

export const EditAsHtmlModal = ({
  isOpen,
  onClose,
  title,
  initialValue,
  onSave,
}: EditAsHtmlModalProps) => {
  const [draftValue, setDraftValue] = useState(initialValue);

  useEffect(() => {
    if (isOpen) {
      setDraftValue(initialValue);
    }
  }, [isOpen, initialValue]);

  const editorConfig = useMemo(
    () => ({
      height: 360,
      statusbar: false,
    }),
    []
  );

  const handleSave = () => {
    onSave(draftValue);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box bg="white" w="100%">
            {isOpen && (
              <JoditEditor
                value={draftValue}
                config={editorConfig}
                onChange={(value) => setDraftValue(value)}
              />
            )}
          </Box>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={handleSave}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
